import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

export function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);
  return (
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-10">
      <h1 className="text-4xl font-extrabold text-midnight">KRVMart Journal</h1>
      <p className="mt-1 text-muted-foreground">Guides, inspiration and product education across Home, Style, Furniture and Tech.</p>
      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((b, i) => (
          <Reveal key={b.slug} delay={(i % 3) * 0.06}>
            <Link to={`/blog/${b.slug}`} data-testid={`blog-${b.slug}`} className="group block overflow-hidden rounded-3xl border border-border bg-card transition-shadow hover:shadow-lg">
              <div className="aspect-video overflow-hidden"><img src={b.image} alt={b.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
              <div className="p-6">
                <span className="text-[11px] font-bold uppercase tracking-wide text-gold-dark">{b.category}</span>
                <h3 className="mt-1 text-lg font-bold text-midnight">{b.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{b.excerpt}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [slug]);
  if (!p) return <div className="py-32 text-center text-muted-foreground">Loading…</div>;
  return (
    <article className="mx-auto max-w-3xl px-4 md:px-8 py-10">
      <Link to="/blog" className="text-sm text-muted-foreground hover:text-midnight">← Journal</Link>
      <span className="mt-4 block text-xs font-bold uppercase tracking-wide text-gold-dark">{p.category}</span>
      <h1 className="mt-2 text-4xl font-extrabold text-midnight">{p.title}</h1>
      <img src={p.image} alt={p.title} className="mt-6 aspect-video w-full rounded-3xl object-cover" />
      <p className="mt-6 text-lg leading-relaxed text-muted-foreground">{p.content}</p>
    </article>
  );
}
